import React from 'react';

import {
	ImageWrapper,
	// eslint-disable-next-line import/no-unresolved
} from './custom.styled.UNIVERSITY';

export const Image = ( { foto, standort, l10n } ) => {
	return (
		<ImageWrapper>
			<img
				loading="lazy"
				src={ foto.url }
				alt={ foto.alt || `${ l10n.subline } ${ standort }` }
			/>
		</ImageWrapper>
	);
};
